import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const CTA = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6 text-sage-800">
          Ready to Make Your Images Accessible?
        </h2>
        <p className="text-xl text-sage-600 mb-8 max-w-2xl mx-auto">
          Join thousands of websites already using AltTextWizard to create accessible, SEO-optimized image content.
        </p>
        <Link to="/auth">
          <Button size="lg" className="animate-fadeIn">
            Get Started Now
            <ArrowRight className="ml-2" />
          </Button>
        </Link>
      </div>
    </section>
  );
};